import { FETCH_PT_GLOBAL } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface PatientRes {
    username: string;
    mobile: string;
    oid: string;
    fln: string;
}

export default (q: string, param: string): Promise<PatientRes[]> =>
    fetchWithRefresh(FETCH_PT_GLOBAL(q, param)).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error("Couldn't fetch pt search results");
        }
    });
